export const CSV_HEADERS = [
  { label: 'Name', key: 'name' },
  { label: 'Total time', key: 'total_time' },
  { label: 'Successful', key: 'successful' },
  { label: 'Mis-click rate', key: 'mis_click_rate' }
];
